import React, {useEffect, useState} from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IonContent, IonHeader, IonPage, IonProgressBar, IonTextarea, IonButton, IonLabel } from '@ionic/react';
import HeaderApp from '../components/HeaderApp';
import '../pages/css/common.css';
import { formatDateForItem } from '../services/utils';
import { IActivityLogSearchResult, ILogSearch_Response, IActivityLogResult, IActivityLogResult_Response } from '../domain/ActivityLog';
import { getActivityLogByIdAsync, getActivityLogListAsync } from '../services/asyncDataService';
import { Plugins } from '@capacitor/core';

const { Network } = Plugins;

const defaultHarborID =  window.localStorage.getItem("defaultClient");

const Download: React.FC<RouteComponentProps> = ({history, location, match}) => {
  const [pinValue, setPinValue] = useState(0);
  const [recentValue, setRecentValue] = useState(0);
  const [progressValue, setProgressValue] = useState(0);
  const [displayText, setDisplayText] =  useState('');
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState("Downloading ...");
  const [downloadedMessage, setDownloadedMessage] = useState("");
  const [isDownloadedVisibile, setIsDownloadedVisible] = useState(false);
  const [downloadButtonLabel, setDownloadButtonLabel] = useState("Download");
  const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");

  useEffect(() => {
    Network.addListener("networkStatusChange", status => {
      setIsOnline(status.connected);
      if (status.connected)
        window.localStorage.setItem("online", "1");
      else
        window.localStorage.setItem("online", "0");
    });

    return () => Network.removeAllListeners(); 
  }, [])

  useEffect(() => {
    let _pinValue = window.localStorage.getItem("pinValue");
    if (_pinValue) {
      setPinValue(Number(_pinValue));
    }

    let _recentValue = window.localStorage.getItem("recentValue");
    if (_recentValue) {
      setRecentValue(Number(_recentValue));
    }
 
    if (isOnline) {
      setDisplayText("Download data for offline use.");
      setDownloadButtonLabel("Download");

      let offlineUpdateDate =  window.localStorage.getItem("offlineUpdateDate");
      let offlineActivityLogList =  window.localStorage.getItem("offlineActivityLogList");
      if (offlineUpdateDate && offlineActivityLogList) {
        setDisplayText("Update your offline data.");
        setDownloadButtonLabel("Update");
        setDownloadedMessage("Your last download date is " + formatDateForItem(String(offlineUpdateDate)));
        setIsDownloadedVisible(true);
      } 
    }
  }, [isOnline]);

  const download = async() => {
    setDownloadMessage("Downloading ...");
    setIsProgressVisible(true);
    let l_harbor = "-1";
    if (defaultHarborID)
      l_harbor =  String(defaultHarborID);
      
    let l_staffPerson = "null";
    let l_timePeriod = "4";
    let l_searchText = "";
    let l_activityTypeId = 0;    
    let l_status:boolean = false;
    let l_person:string =''; 
    let l_pinned: boolean = false; 

    let _token = window.localStorage.getItem("token");
    if (_token) {
      let response = await getActivityLogListAsync(_token, l_harbor, l_timePeriod, '', '', l_staffPerson, 
                                    l_searchText, l_activityTypeId, l_pinned, l_person, l_status);
      if ((response as any).data && (response as any).data.length > 0 ) {
        let expectedData =  (response as any).data;
        let activityLogList = (JSON.parse(expectedData.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
        let activityLogCount: number = activityLogList.length;
        let progressCount = 0;

        let activityLogListToStore: IActivityLogResult[] = [];
        for (let item  of activityLogList) {
          let _id= item.ActivityLogID.toString();
          let itemResponse = await getActivityLogByIdAsync(String(_token), _id);
          if ((itemResponse as any).data && (itemResponse as any).data.length > 0) {
            let itemExpectedData =  (itemResponse as any).data;
            let itemToStore = (JSON.parse(itemExpectedData.toString()) as IActivityLogResult_Response).Result;
            activityLogListToStore.push(itemToStore);
            progressCount++;
            setProgressValue((progressCount/activityLogCount));       
          }
        }
        window.localStorage.setItem("offlineActivityLogList", JSON.stringify(activityLogListToStore));
        window.localStorage.setItem("offlineUpdateDate", new Date().toISOString());
        setDownloadMessage("Download finished!");
      }
      else {       
      }
    }
    else {
      
    }
  }

  return (
    <IonPage>
      <IonHeader mode="ios">
        <HeaderApp pinValue={pinValue} recentValue={recentValue} history={history} location={location} match={match} isOnline={isOnline}></HeaderApp>
      </IonHeader>
      <IonContent fullscreen>
          {isDownloadedVisibile &&
            <IonTextarea value={downloadedMessage} class="my-download-textarea"></IonTextarea> 
          }
          {isOnline &&
            <>
              <IonTextarea value={displayText} class="my-download-textarea"></IonTextarea>
              <IonButton mode="ios" class="my-download-button" onClick={download}>{downloadButtonLabel}</IonButton>
              {isProgressVisible &&
                <>
                  <IonLabel class="my-download-label" color="success">{downloadMessage}</IonLabel>
                  <IonProgressBar class="my-progressBar" value={progressValue} color="success"></IonProgressBar>
                </>
              } 
            </> 
          }
      </IonContent>
    </IonPage>
  );
};

export default Download;
